import React, { forwardRef } from "react";
import { Container, Row, Col, Table } from 'react-bootstrap';
import { Divider, Descriptions, Row as ARow, Col as ACol, Tag, Alert, Image, QRCode, Space } from 'antd';
import { EyeFill, EarFill } from 'react-bootstrap-icons';
import 'bootstrap/dist/css/bootstrap.min.css';
import moment from 'moment';
import Moment from 'react-moment';
import Common from "./includes/Common";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var LaboratorySheet = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var queue_item = _ref.queue_item;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs("div", {
        ref: ref,
        id: "printable",
        style: {
          padding: "20px"
        },
        children: [/*#__PURE__*/_jsx(ARow, {
          gutter: 16,
          children: /*#__PURE__*/_jsx(ACol, {
            className: "gutter-row",
            span: 24,
            children: /*#__PURE__*/_jsx(Image, {
              preview: false,
              width: "100%",
              src: "/drawables/emge.png"
            })
          })
        }), /*#__PURE__*/_jsx("h4", {
          style: {
            textAlign: "center",
            marginTop: '20px'
          },
          children: /*#__PURE__*/_jsx("b", {
            children: "RESULTAT DU LABORATOIRE BIOLOGIQUE"
          })
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(ARow, {
          children: /*#__PURE__*/_jsx(ACol, {
            span: 24,
            children: queue_item && queue_item.queue_item_elements.length > 0 && /*#__PURE__*/_jsxs(Table, {
              bordered: true,
              responsive: true,
              children: [/*#__PURE__*/_jsx("thead", {
                children: /*#__PURE__*/_jsxs("tr", {
                  children: [/*#__PURE__*/_jsx("td", {
                    children: "N.Echantillon"
                  }), /*#__PURE__*/_jsx("td", {
                    children: "Examen"
                  }), /*#__PURE__*/_jsx("td", {
                    children: "Resultat"
                  }), /*#__PURE__*/_jsx("td", {
                    children: "Valeur normale"
                  })]
                })
              }), /*#__PURE__*/_jsx("tbody", {
                children: queue_item.queue_item_elements.map(function (e) {
                  return e.laboratory_result_id != null && /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: e.laboratory_result.sample_id
                    }), /*#__PURE__*/_jsx("td", {
                      children: e.medical_item.label
                    }), /*#__PURE__*/_jsx("td", {
                      children: e.laboratory_result.result_string
                    }), /*#__PURE__*/_jsx("td", {
                      children: e.medical_item.standard
                    })]
                  }, e.id);
                })
              })]
            })
          })
        }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(ARow, {
          children: /*#__PURE__*/_jsx(ACol, {
            span: 8,
            children: /*#__PURE__*/_jsx("div", {
              style: {
                textAlign: 'center'
              },
              children: /*#__PURE__*/_jsx("h5", {
                children: "Le Responsable du Laboratoire"
              })
            })
          })
        }), /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            style: {
              "float": 'left',
              width: '46%'
            },
            lg: 6,
            md: 6,
            sm: 6
          }), /*#__PURE__*/_jsx(Col, {
            style: {
              "float": 'left',
              width: '46%'
            },
            className: "g-col-6",
            lg: 6,
            md: 6,
            sm: 6
          })]
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), " ", /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {})]
      })
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {})]
  });
});
export default LaboratorySheet;